import React from "react";
import PropTypes from "prop-types";
import MaterialIcon from "components/common/MaterialIcon";
import {
  Input,
  Modal,
  Button,
  Select,
  Row,
  Col,
  Checkbox,
  Form,
  InputNumber,
  Switch,
  Radio,
  Slider,
  Upload,
  Icon,
} from "antd";

@autobind
/**
 *
 */
export default class TestPrint extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
  };
  static defaultProps = {
    visible: false,
    onCancel: () => {},
    onSubmit: () => {},
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);

    this.templates = app.local.load("reportTemplates");

    this.state = {
      pagePrint: true,
    };
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { visible, onCancel, onSubmit } = this.props;
    let pagePrint = this.state.pagePrint;
    console.log(" ");
    return (
      <Modal
        visible={visible}
        onCancel={onCancel}
        title="آماده سازی جهت چاپ"
        footer={[
          <Button key="back" size="large" onClick={onCancel}>
            {app.translate("main.Cancel")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={false}
            size="large"
            onClick={() => {
              let style = { css: "" };
              if (pagePrint) {
                style = {
                  css: `<style>.report-table:not(:first-child) {page-break-before: always;}</style>`,
                };
              }
              onSubmit(pagePrint, style);
            }}
          >
            {app.translate("main.Print")}
          </Button>,
        ]}
      >
        <div className="customReport">
          <Checkbox
            checked={pagePrint}
            onChange={(e) => {
              this.setState({ pagePrint: e.target.checked });
            }}
          >
            چاپ در صفحات جداگانه
          </Checkbox>
        </div>
      </Modal>
    );
  }
}
